<template>
  <div
    class="flex items-center justify-between px-4 py-2.5 border-1 border-secondary-250 rounded-md w-full">
    <!-- Show this when there's a src -->
    <div v-if="src" class="flex items-center justify-between w-full">
      <span
        class="text-sm font-simplerBold text-secondary-900 truncate max-w-[calc(100%-2.5rem)]">
        {{ src }}
      </span>
      <div
        class="flex items-center justify-center border-1 cursor-pointer border-secondary-300 rounded-lg bg-secondary-100 w-8 h-8"
        @click.stop="clearSource">
        <XIcon class="stroke-secondary-975 h-4" />
      </div>
    </div>

    <!-- Show this when there's no src -->
    <div
      v-else
      class="flex items-center justify-between w-full cursor-pointer"
      @click.prevent="openWidget">
      <span class="text-sm font-simplerBold text-secondary-900">
        {{ label }}
      </span>
      <div
        class="flex items-center justify-center border-1 border-secondary-300 rounded-lg bg-secondary-100 w-8 h-8">
        <UploadIcon class="stroke-secondary-975 h-4" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import {
  defaultSources,
  reactiveUploadResult,
  updateAndOpenInstance,
} from '@amit/composables';
import { Upload as UploadIcon, X as XIcon } from 'lucide-vue-next';
import type { PropType } from 'vue';
import { imageFormats, videoFormats } from '@amit/foundation/utils';

type mediaType = 'image' | 'video';
const formats: Record<mediaType, Array<string>> = {
  image: imageFormats,
  video: videoFormats,
};

const emit = defineEmits(['upload']);

const src = defineModel<string>();

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String as PropType<mediaType>,
    default: 'image',
  },
  blockId: {
    type: String,
    default: '',
  },
});

const allowedFormats = computed(() => {
  return formats[props.type];
});

const openWidget = () => {
  const sources =
    props.type === 'image'
      ? defaultSources
      : defaultSources.filter(source => source !== 'unsplash');
  updateAndOpenInstance(
    {
      clientAllowedFormats: allowedFormats.value,
      resourceType: props.type,
      sources,
    },
    // TODO: check this
    props.blockId,
  );
};

const clearSource = () => {
  src.value = '';
};

watch(
  () => reactiveUploadResult.value,
  () => {
    if (
      // TODO: check this
      reactiveUploadResult.value.block === props.blockId &&
      reactiveUploadResult.value.type === 'success'
    ) {
      emit('upload', reactiveUploadResult.value.result);
    }
  },
  { deep: true },
);
</script>
